import { render, staticRenderFns } from "./ZghForm.vue?vue&type=template&id=7e5c21f2&scoped=true"
import script from "./ZghForm.vue?vue&type=script&lang=js"
export * from "./ZghForm.vue?vue&type=script&lang=js"
import style0 from "./ZghForm.vue?vue&type=style&index=0&id=7e5c21f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5c21f2",
  null
  
)

export default component.exports